/**
 * File: twoRowCarousel.js.
 *
 * Import and initialize functions for Two Row Carousel
 */

 const $ = require('jquery');
 import 'slick-carousel';

 export default {
	init() {
		this.render();
	},
	render() {
		const twoRowCarousel = document.querySelector('.two-row-slick-js .ecs-posts');
		if (twoRowCarousel) {
			$(twoRowCarousel).slick({
				rows: 2,
				dots: false,
				arrows: false,
				infinite: true,
				autoplay: true,
				autoplaySpeed: 1000,
				speed: 500,
				slidesToShow: 5,
				slidesToScroll: 1,
				centerMode: true,
				centerPadding: '10%',
				responsive: [
				{
					breakpoint: 1000,
					settings: {
					centerMode: false,
					slidesToShow: 3,
					}
				},
				{
					breakpoint: 700,
					settings: {
					centerMode: false,
					slidesToShow: 2,
					}
				}
				]
		});
		}
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
  